import LegalMenu from "./legal-menu";


export default LegalMenu;